import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { IRootState } from 'store';
import { sendNotification } from 'actions/send-grid-notifications';
import anetaMembership from 'components/email-templates/anetaMembership';
import { changeRootLink } from 'actions/auth';
import { connect, useDispatch } from 'react-redux';
import Logo from 'components/common/logo';
import RobotRight from 'style/imgs/robot-right-direction.svg';
import buttons from 'style/buttons.module.scss';
import styles from './index.module.scss';

const mstp = (state: IRootState) => ({
  email: state.users.userData?.email,
  userType: state.users.userData?.type,
});
type Props = ReturnType<typeof mstp>;

const SuccessfulRegistration: React.FC<Props> = ({ email, userType }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const rootLink =
    userType === 'parent' ? '/process-steps' : '/process-steps-admin';

  useEffect(() => {
    if (email) {
      dispatch(sendNotification([email], anetaMembership));
    }
    dispatch(changeRootLink(rootLink));
  }, [dispatch, email, userType, rootLink]);

  return (
    <div className={styles.welcome}>
      <div className={styles.welcomeLeft}>
        <div className={styles.robot}>
          <img src={RobotRight} alt="img" />
        </div>
      </div>
      <div className={styles.welcomeRight}>
        <div>
          <div className={styles.logo}>
            <Logo />
          </div>
          <h1 className="deep-gray-heading bold">
            Congratulations! <br /> You have been successfully registered!
          </h1>
          <p className="gray-text">
            Digital organization and wayfinding for scholars of any age.
          </p>
          <button
            type="button"
            onClick={() => history.push(rootLink)}
            className={buttons.buttonOrange}
          >
            Next
          </button>
        </div>
        <a
          href="https://anetaed.zendesk.com/hc/en-us"
          target="_blank"
          rel="noreferrer"
          className="question"
        >
          ?
        </a>
      </div>
    </div>
  );
};

export default connect(mstp)(SuccessfulRegistration);
